import { useMemo } from 'react';
import useSearch from './use-search';
import rewriteFuel from '../../../helpers/rewriteFuel';
import staticWhere from '../../../where';

const sortString = (a, b) => a.key.localeCompare(b.key);
const sortInt = (a, b) => b.key - a.key;
const map = ({ key, connection }) => ({
  name: key,
  count: connection?.aggregate?.count,
});

export default () => {
  const {
    vehiclesConnection,
    where,
    defaultValues,
  } = useSearch();

  if (!vehiclesConnection) {
    console.warn('[vehicles use-filters] received no vehiclesConnection!');
    return {};
  }

  const {
    makeModels: {
      makes = [],
    } = {},
    bodies: {
      body = [],
    } = {},
    fuels: {
      fuel = [],
    } = {},
    transmissions: {
      transmission = [],
    } = {},
    tax_types: {
      tax_type = [],
    } = {},
    buildyears: {
      buildyear = [],
    } = {},
    colors: {
      color = [],
    } = {},
    base_colors: {
      base_color = [],
    } = {},
    energylabels: {
      energylabel = [],
    } = {},
    max_towings: {
      max_towing = [],
    } = {},
  } = vehiclesConnection;
  const selectedMake = where.make || defaultValues.make || staticWhere.make;

  return useMemo(() => {
    // convert possible String to Array
    const selectedMakes = [
      ...(Array.isArray(selectedMake) ? selectedMake : [selectedMake].filter(Boolean)),
    ];

    // we dont support models for multiple makes, so > 1
    const modelsForSelectedMake = selectedMakes.length === 0 || selectedMakes.length > 1
      ? []
      : (makes.find(({
          key,
        }) => selectedMakes.includes(key))?.connection?.groupBy?.models ?? []);

    return {
      allMakes: makes.sort(sortString).map(map),
      modelsForSelectedMake: modelsForSelectedMake.sort(sortString).map(map),
      bodies: body.sort(sortString).map(map),
      fuels: fuel.sort(sortString).map(map).map((f) => ({
        ...f,
        value: f.name,
        name: rewriteFuel(f.name),
      })),
      transmissions: transmission.sort(sortString).map(map),
      tax_types: tax_type.sort(sortString).map(map),
      buildyears: buildyear.sort(sortInt).map(map),
      colors: color.sort(sortString).map(map),
      base_colors: base_color.sort(sortString).map(map),
      energylabels: energylabel.sort(sortString).map(map),
      max_towings: max_towing.sort(sortInt).map(map).map((item) => ({ ...item, value: item.name, name: `${item.name} kg` })),
    };
  }, [
    selectedMake,
    makes,
    body,
    fuel,
    transmission,
    tax_type,
    buildyear,
    color,
    base_color,
    energylabel,
    max_towing,
  ]);
};
